import { AxiosError } from 'axios';
import { PaymentAccessRequest, PaymentAccessResponse } from 'web-library/models/Payment';
import { GET_POST_PAYMENT_ACCESS_URL } from 'web-library/constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: (data: PaymentAccessResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostPaymentAccess = ({ onSuccess, onError }: Input = {}) => {
  const postPaymentAccess = async (reqBody: PaymentAccessRequest) => {
    const res = await axiosClient.post<PaymentAccessResponse>(GET_POST_PAYMENT_ACCESS_URL, reqBody);
    return res.data;
  };

  return useCustomMutation(postPaymentAccess, {
    onSuccess,
    onError,
  });
};
